import { render, staticRenderFns } from "./AddedSuccess.vue?vue&type=template&id=3bdc823d&"
import script from "./AddedSuccess.vue?vue&type=script&lang=js&"
export * from "./AddedSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AddedSuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports